import * as React from "react";
import {useState} from "react";

import {
    MobileIconMenuAPIContext,
    MobileIconMenuContext,
} from "./mobile-icon-menu-context.ts";

interface Props {
    /**
     * Children to render inside the provider.
     */
    children: React.ReactNode;
}

/**
 * Provide the context to manage the mobile icon menu for the chat input.
 */
export const MobileIconMenuContextProvider = ({
    children,
}: Props): React.ReactElement => {
    const [isMobileIconMenuOpen, setIsMobileIconMenuOpen] = useState(false);
    return (
        <MobileIconMenuAPIContext.Provider value={setIsMobileIconMenuOpen}>
            <MobileIconMenuContext.Provider value={isMobileIconMenuOpen}>
                {children}
            </MobileIconMenuContext.Provider>
        </MobileIconMenuAPIContext.Provider>
    );
};
